import { Action } from "redux";

import { SET_LOGGED_USER, SET_LOADING } from "./types";

interface UserAction extends Action {
  payload: any;
}

const initialState = {
  loggedUser: null,
  loading: false,
};

export default (state = initialState, action: UserAction) => {
  switch (action.type) {
    case SET_LOGGED_USER:
      return {
        ...state,
        loggedUser: action.payload,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};
